import styled from 'styled-components'

export const GoogleButtonWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 53px;
`

export const GoogleButtonContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  opacity: 0.001;
  cursor: pointer;
  overflow: hidden;

  & > div,
  & > div > div {
    width: 100% !important;
    height: 100% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    scale: 1.5;
  }
`

export const CustomGoogleButton = styled.button`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Google Sans', sans-serif;
  gap: 8px;
  padding: 12px 14px;
  border-radius: 26px;
  background-color: #fff;
  color: #283845;
  outline: none;
  border: 1px solid #ccd6e0;
  font-weight: 400;
  font-size: 16px;
  cursor: pointer;
  transition: opacity 0.2s;
  z-index: 1;
  pointer-events: none;
  margin: 0 auto;
`

export const GoogleLogo = styled.img`
  width: 20px;
  height: 20px;
`

export const Separator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 400;
  color: #283845;
  width: 100%;
  text-align: center;
`
